module.exports = __webpack_public_path__ + "static/bonsaicss-icon-398820fe719472e7455bc3f8dbf46c13.png";